export function decodeHtml(html?: string): string {
  if (!html) return ''
  const textarea = document.createElement('textarea')
  textarea.innerHTML = html
  return textarea.value
}

export default decodeHtml
